import { FC } from "react";
import { HELP_CENTER_URI } from "config/menu/common";

const HelpCenter: FC = () => {
  window.open(HELP_CENTER_URI, "_blank");
  return null;
};

export default HelpCenter;
